import {faTelegram, faVk, faGithub, faLinkedin} from '@fortawesome/free-brands-svg-icons'

export const socialLinks = [
    {href: 'https://t.me/yurik_0007', icon: faTelegram, label: 'Telegram'},
    {href: 'https://vk.ru/id47846562', icon: faVk, label: 'VK'},
    {href: 'https://www.linkedin.com/in/yurik-tim', icon: faLinkedin, label: 'LinkedIn'},
    {href: 'https://github.com/Yurik-00007', icon: faGithub, label: 'GitHub'},
]
